import { render, staticRenderFns } from "./LatestActivity.vue?vue&type=template&id=f0c97cd0&"
import script from "./LatestActivity.vue?vue&type=script&lang=js&"
export * from "./LatestActivity.vue?vue&type=script&lang=js&"
import style0 from "./LatestActivity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports